export const getOrderActions = (order) => {
  if (!order?.status?.value) return [];

  const status = order.status.value;
  const paymentStatus = order?.payment_status?.value;
  const type = order?.type?.value;

  const actions = [];

  // package orders
  if (type === "package") {
    if (status !== "cancelled") actions.push("cancel_order");
    return actions;
  }

  // delivered
  if (status === "delivered") {
    if (paymentStatus === "paid") {
      actions.push("refund_item", "refund_full_order");
    }
    actions.push("send_voucher");
    return actions;
  }

  // cancelled
  if (status === "cancelled") {
    if (paymentStatus === "paid") {
      actions.push("refund_full_order", "send_voucher");
    }
    return actions;
  }

  // processing / pending
  if (["processing", "pending"].includes(status)) {
    actions.push("cancel_order");

    
      actions.push("replace_item", "send_voucher");
    
    return actions;
  }

  return actions;
};